import { render, staticRenderFns } from "./PosInvoiceReceipt58mm.vue?vue&type=template&id=9327839e&scoped=true&"
import script from "./PosInvoiceReceipt58mm.vue?vue&type=script&lang=js&"
export * from "./PosInvoiceReceipt58mm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9327839e",
  null
  
)

export default component.exports